import { jsx as i, jsxs as v, Fragment as I } from "react/jsx-runtime";
import k, { useState as E, useId as T, useEffect as F, cloneElement as w } from "react";
import { c as y } from "../clsx-OuTLNxxd.js";
import { A as R, E as U } from "../index-CeQ14xPc.js";
import '../Accordion.css';const j = "320px", L = "600px", O = "1025px", D = "_header_zq4vr_33", G = "_splitHeader_zq4vr_37", J = "_iconSlot_zq4vr_43", K = "_heading_zq4vr_50", Q = "_toggle_zq4vr_57", X = "_triggerElement_zq4vr_66", Y = "_indicator_zq4vr_72", Z = "_trigger_zq4vr_66", M = "_contentElement_zq4vr_112", V = "_content_zq4vr_112", C = "_primary_zq4vr_132", N = "_secondary_zq4vr_135", ee = "_item_zq4vr_141", te = "_dense_zq4vr_141", ne = "_nav_zq4vr_234", ie = "_link_zq4vr_239", oe = "_headingText_zq4vr_271", re = "_linkLabel_zq4vr_272", ce = "_linkList_zq4vr_297", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: j,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ne,
  link: ie,
  headingText: oe,
  linkLabel: re,
  linkList: ce
}, le = (d) => {
  if (typeof requestAnimationFrame != "function")
    return d(), () => {
    };
  let x = 0;
  const r = requestAnimationFrame(() => {
    x = requestAnimationFrame(d);
  });
  return () => {
    cancelAnimationFrame(r), cancelAnimationFrame(x);
  };
}, de = ({
  animationDurationMs: d = 0,
  indicatorSize: x = "s",
  isOpen: r,
  isPanelLandmark: e = !0,
  onChange: g,
  stroke: S = "bold"
}) => {
  const [n, m] = E(r), s = d > 0, [f, p] = E(r), [u, a] = E(!!r), z = T(), h = T(), b = () => {
    g == null || g(!n), m(!n);
  };
  F(() => {
    r !== n && m(r);
  }, [r]), F(() => {
    if (!s) return;
    if (n)
      return p(!0), le(() => a(!0));
    a(!1);
    const c = setTimeout(() => p(!1), d);
    return () => clearTimeout(c);
  }, [n, s, d]);
  const _ = {
    "aria-controls": h,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": n,
    "data-state": n ? "open" : "closed",
    id: z,
    onClick: b
  }, o = {
    "aria-labelledby": z,
    className: t.contentElement,
    hidden: s ? !f : !n,
    id: h,
    ...e ? { role: "region" } : {},
    ...s ? { "data-animated": "" } : {},
    ...s && u ? { "data-enter": "" } : {}
  };
  return {
    headingProps: _,
    sectionProps: o,
    triggerClass: t.triggerElement,
    Indicator: () => S === "bold" ? /* @__PURE__ */ i(R, { className: t.indicator, size: x }) : /* @__PURE__ */ i(U, { className: t.indicator, size: x })
  };
}, me = 300, xe = ({
  animationDurationMs: d = 0,
  chevronStroke: x = "bold",
  children: r,
  classNames: e,
  heading: g,
  headingAs: S = "h3",
  icon: n,
  indicator: m,
  indicatorSize: s = "s",
  isDense: f = !1,
  isOpen: p = !1,
  isPanelLandmark: u = !0,
  links: a,
  onChange: z,
  onLinkClick: h,
  testId: b,
  toggleLabel: _,
  trackingAttribute: o,
  variant: c
}) => {
  const { Indicator: l, headingProps: q, sectionProps: W, triggerClass: A } = de({
    animationDurationMs: d,
    isOpen: p,
    isPanelLandmark: u,
    onChange: z,
    indicatorSize: s,
    stroke: x
  }), B = {
    ...q,
    ...o ? { "data-analytics": o } : {},
    ...b ? { "data-testid": b } : {},
    type: "button"
  }, { id: P, ...$ } = B;
  return /* @__PURE__ */ v(
    "div",
    {
      className: y(
        t.item,
        { [t.dense]: f },
        c && c !== "bare" && t[c],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ i(S, { className: y(t.header, { [t.splitHeader]: _ }, e == null ? void 0 : e.header), children: _ ? /* @__PURE__ */ v(I, { children: [
          /* @__PURE__ */ v("span", { className: y(t.heading, e == null ? void 0 : e.heading), id: P, children: [
            n !== void 0 && /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            g
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              "aria-label": _,
              className: y(A, t.toggle, e == null ? void 0 : e.button),
              ...$,
              children: m ?? /* @__PURE__ */ i(l, {})
            }
          )
        ] }) : /* @__PURE__ */ v("button", { className: y(A, t.trigger, e == null ? void 0 : e.button), ...B, children: [
          n === void 0 ? g : /* @__PURE__ */ v(I, { children: [
            /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            /* @__PURE__ */ i("span", { className: y(t.headingText, e == null ? void 0 : e.heading), children: g })
          ] }),
          m ?? /* @__PURE__ */ i(l, {})
        ] }) }),
        /* @__PURE__ */ i(
          "div",
          {
            ...W,
            className: y(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${d}ms` },
            children: a ? /* @__PURE__ */ i("ul", { className: t.linkList, children: a.map((H) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ v("a", { className: t.link, href: H.href, onClick: () => h == null ? void 0 : h(H), children: [
              /* @__PURE__ */ i("span", { className: t.iconSlot, children: H.icon }),
              /* @__PURE__ */ i("span", { className: t.linkLabel, children: H.label })
            ] }) }, `${H.href}-${H.label}`)) }) : r
          }
        )
      ]
    }
  );
}, se = ({
  chevronStroke: d = "bold",
  children: x,
  defaultOpen: r,
  indicatorSize: e = "s",
  isDense: g = !1,
  name: S,
  onValueChange: n,
  type: m = "single",
  value: s,
  variant: f = "primary"
}) => {
  const p = m === "multiple", u = s !== void 0, a = k.Children.toArray(x), z = r ? a.map(() => !0) : a.map((o) => !!o.props.isOpen), [h, b] = E(z), _ = (o, c) => {
    let l = [];
    p ? (l = [...h], l[c] = o) : (l = a.map(() => !1), o === !0 && (l[c] = !0)), b(l);
  };
  return /* @__PURE__ */ i(
    "div",
    {
      className: y(t.accordion, f !== "bare" && t[f]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && a.map(
        (o, c) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          w(o, {
            chevronStroke: d,
            indicatorSize: e,
            isDense: g,
            variant: f,
            isOpen: u ? o.props.value === s : h[c],
            key: `${S}-item-${c}`,
            onChange: (l) => {
              var q, W;
              (W = (q = o.props).onChange) == null || W.call(q, l), u ? n == null || n(l ? o.props.value ?? null : null) : _(l, c);
            }
          })
        )
      )
    }
  );
};
se.Item = xe;
export {
  me as ACCORDION_FADE_DURATION_MS,
  se as Accordion,
  de as useToggle
};
